import { render, staticRenderFns } from "./DroneDetailsDialog.vue?vue&type=template&id=190b4549&"
import script from "./DroneDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./DroneDetailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./DroneDetailsDialog.vue?vue&type=style&index=0&id=190b4549&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports